import { AuthenticationEntity } from "@modules/auth/entities/auth.entity";
import { API_HEADER, API_URL } from "@modules/shared/enums/common-enum";
import { fetchWithAuth } from "@modules/shared/helpers/fetch-with-auth.helper";

export const FeatureFlagService = {
  async getAllFeatureFlags(
    auth: AuthenticationEntity,
    setAuth: (auth: AuthenticationEntity | null) => void,
    logout: () => void,
  ) {
    let res = await fetchWithAuth(
      `${API_URL.FEATURE_FLAGS}`,
      {
        method: "GET",
        headers: {
          ...API_HEADER,
          "x-platform": "web",
        },
      },
      auth,
      setAuth,
      logout,
    );

    return res;
  },

  async createFeatureFlag(
    auth: AuthenticationEntity,
    setAuth: (auth: AuthenticationEntity | null) => void,
    logout: () => void,
    featureId: string,
    description: string,
    status: "ACTIVE" | "INACTIVE",
    rolloutPercentage: number,
    androidMinVersion: string,
    iosMinVersion: string,
    level: number,
  ) {
    let res = await fetchWithAuth(
      `${API_URL.FEATURE_FLAGS}`,
      {
        method: "POST",
        headers: {
          ...API_HEADER,
          "x-platform": "web",
        },
        body: JSON.stringify({
          feature_id: featureId,
          description,
          status,
          rollout_percentage: rolloutPercentage,
          android_min_version: androidMinVersion,
          ios_min_version: iosMinVersion,
          level,
        }),
      },
      auth,
      setAuth,
      logout,
    );

    return res;
  },

  async updateFeatureFlag(
    auth: AuthenticationEntity,
    setAuth: (auth: AuthenticationEntity | null) => void,
    logout: () => void,
    featureId: string,
    description: string,
    status: "ACTIVE" | "INACTIVE",
    rolloutPercentage: number,
    androidMinVersion: string,
    iosMinVersion: string,
    level: number,
  ) {
    let res = await fetchWithAuth(
      `${API_URL.FEATURE_FLAGS}/feature/${featureId}`,
      {
        method: "PUT",
        headers: {
          ...API_HEADER,
          "x-platform": "web",
        },
        body: JSON.stringify({
          feature_id: featureId,
          description,
          status,
          rollout_percentage: rolloutPercentage,
          android_min_version: androidMinVersion,
          ios_min_version: iosMinVersion,
          level,
        }),
      },
      auth,
      setAuth,
      logout,
    );

    return res;
  },

  async deleteFeatureFlag(
    auth: AuthenticationEntity,
    setAuth: (auth: AuthenticationEntity | null) => void,
    logout: () => void,
    featureId: string,
  ) {
    let res = await fetchWithAuth(
      `${API_URL.FEATURE_FLAGS}/feature/${featureId}`,
      {
        method: "DELETE",
        headers: {
          ...API_HEADER,
          "x-platform": "web",
        },
      },
      auth,
      setAuth,
      logout,
    );

    return res;
  },

  async getAppVersionConfig(
    auth: AuthenticationEntity,
    setAuth: (auth: AuthenticationEntity | null) => void,
    logout: () => void,
  ) {
    return fetchWithAuth(
      API_URL.APP_VERSION_CONFIG,
      {
        method: "GET",
        headers: {
          ...API_HEADER,
          "x-platform": "web",
        },
      },
      auth,
      setAuth,
      logout,
    );
  },

  async updateAppVersionConfig(
    auth: AuthenticationEntity,
    setAuth: (auth: AuthenticationEntity | null) => void,
    logout: () => void,
    iosMinVersion: string,
    androidMinVersion: string,
  ) {
    return fetchWithAuth(
      API_URL.APP_VERSION_CONFIG,
      {
        method: "PUT",
        headers: {
          ...API_HEADER,
          "x-platform": "web",
        },
        body: JSON.stringify({
          ios_min_version: iosMinVersion,
          android_min_version: androidMinVersion,
        }),
      },
      auth,
      setAuth,
      logout,
    );
  },
};
